import { AlertTriangle, ChevronRight, Info } from "lucide-react";
import { timeAgo } from "@/lib/timeAgo";
import type { Alert } from "@/features/alert/types";
import { getAlertPreviewText, getAlertTypeLabel } from "./alertCardRules";

type NotificationPreviewRowProps = {
  alert: Alert;
  onSelect: () => void;
  isPending: boolean;
};

export function NotificationPreviewRow({
  alert,
  onSelect,
  isPending,
}: NotificationPreviewRowProps) {
  const { title, context } = getAlertPreviewText(alert);
  const Icon = alert.actionable ? AlertTriangle : Info;

  return (
    <button
      type="button"
      className="notification-tray-row"
      data-actionable={alert.actionable || undefined}
      onClick={onSelect}
      disabled={isPending}
    >
      <span className="notification-tray-row__icon" aria-hidden="true">
        <Icon size={16} />
      </span>
      <span className="notification-tray-row__copy">
        <span className="notification-tray-row__meta">
          <span>{getAlertTypeLabel(alert.alert_type)}</span>
          <time>{timeAgo(alert.created_at)}</time>
        </span>
        <strong>{title}</strong>
        <small>{context}</small>
      </span>
      <ChevronRight className="notification-tray-row__chevron" size={17} />
    </button>
  );
}
